
import React, { useState, useEffect, useRef } from "react";
import { getaxiosRequestWithToken, postaxiosRequestWithToken ,deleteaxiosRequestWithToken} from "../../api/api";
import { FiShoppingBag, FiTrash2 } from 'react-icons/fi';
import { showToast } from '../../services/toastifyservices';
import { handleSession } from '../../api/apiSessionHandle'
import { useNavigate } from 'react-router-dom';
import CommonSpinner from '../../services/commonSpinner';
import Swal from "sweetalert2";
import './document.css';
import endpoints from "../../api/EndPoints";

const Document = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [AssistantName, setAssistantName] = useState("");
    const [Location, setLocation] = useState([]);
    const [location_id, setLocationId] = useState("");
    const [date, setDate] = useState("");
    const [documentdata, setdocumentdata] = useState([]);
    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"))
        setAssistantName(user.name)
        fetchLocation();
    }, [navigate]);
    //<-----------------End Task Section------------->
    const fetchLocation = async () => {
        try {
            const response = await getaxiosRequestWithToken(endpoints.locations);
            if (response.success) {
                setLocation(response.data.addresses || []);
            }
        } catch (error) {
            showToast('error', error.response?.data.message);
            handleSession(error.response?.data, navigate);
        } finally {
            setLoading(false);
        }
    };

    //--------------------------on Search Button---------------------//
    const handleSearch = async (e) => {
        if (e) {
            e.preventDefault();
        }
        if (!location_id && !date){
            showToast("error", "Please select location and date");
            return;
        }
        if (!location_id) {
            showToast("error", "Please select location");
            return;
        }
        if (!date) {
            showToast("error", "Please select date");
            return;
        }
        setLoading(true);
        const Payload = {
            location_id: location_id,
            date: date
        };
        try {
            const response = await getaxiosRequestWithToken(endpoints.GetDocuments, Payload);
            if (response.success) {
                setLoading(false);
                if (response.documents.length > 0) {
                    setdocumentdata(response.documents);
                } else {
                    showToast("error", "No Record Found");

                }
            }
        } catch (error) {
            showToast('error', error.response?.data.message);
            setLoading(false);
            handleSession(error.response?.data, navigate);
            handleSession(error.response.data, navigate);
        }
    };

    // useEffect(() => {
    //     const fetchData = async () => {
    //         setLoading(true);
    //         try {
    //             const response = await getaxiosRequestWithToken(endpoints.GetPatientDocs);
    //             if (response.success) {
    //                 const normalizedData = (response.data.data || []).map((item) => ({
    //                     id: item.id,
    //                     patient_name: `${item.patient_pool?.first_name || ""} ${item.patient_pool?.last_name || ""}`,
    //                     file_path: item.url,
    //                     source : "get-patient-docs"
    //                 }));
    //                 setdocumentdata(normalizedData);
    //             } else {
    //                 showToast("error", "No Record Found");
    //             }
    //         } catch (error) {
    //             showToast('error', error.response?.data.message);
    //             handleSession(error.response?.data, navigate);
    //         } finally {
    //             setLoading(false);
    //             setRefresh(false)
    //         }
    //     };

    //     fetchData();
    // },[refresh])

    const handleDocumentClick = (filePath) => {
        window.open(filePath, '_blank');
    };

    const handleDelete = async (documentId) => {
        Swal.fire({
            title: "Do you want to delete this?",
            showCancelButton: true,
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel",
            icon: "question"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const document = documentdata.find((doc) => doc.id === documentId); 
                    if (!document) return; 
    
                    const params = { id: documentId };
                    let response;
                    if (document.source === "get-patient-docs") {
                        response = await deleteaxiosRequestWithToken("delete-patient-doc",documentId);
                    } else {
                        response = await postaxiosRequestWithToken("delete-document", params);
                    }
    
                    if (response.success) {
                        showToast("success", "Document deleted successfully");
                        if (date && location_id) {
                            handleSearch();
                        }
                        else{
                            setRefresh(true)
                        }
                    } else {
                        showToast("error", response.message || "Failed to delete the document");
                    }
                } catch (error) {
                    showToast("error", "An unexpected error occurred while deleting the document");
                }
            }
        });
    };
    



    return (
        <div className="mt-3 p-2 md:p-10 bg-gray-200">
            <div className="card">
                <span className="text-start font-bold ml-4 p-2 headingtext">Documents</span>
            </div>
            <form onSubmit={handleSearch}>
                <div className="card mt-3">
                    <div className="row mt-3 mb-2 py-2">
                        <div className="col-md-3 ml-3">
                            <label
                                htmlFor="statusSelect"
                                className="form-label font-bold mb-1" // `mb-1` to add some space between the label and the dropdown
                                style={{ display: 'block' }} // Ensure label takes up full width
                            >
                                Location <span className="text-red">*</span>
                            </label>
                            <div className="d-flex">
                                <select
                                    className="form-select"
                                    aria-label="Default select example"
                                    id="locationselect"
                                    value={location_id}
                                    onChange={(e) => setLocationId(e.target.value)}
                                   // required
                                >
                                    <option value="">Select Location</option>
                                    {Location.map((location) => (
                                        <option key={location.location_id} value={location.location_id}>
                                            {location.city}
                                        </option>
                                    ))}
                                </select>

                            </div>
                        </div>
                        <div className="col-md-3">
                            <label
                                htmlFor="statusSelect"
                                className="form-label font-bold mb-1"
                                style={{ display: 'block' }}
                            >
                                Date <span className="text-red">*</span>
                            </label>
                            <input
                                type="date"
                                className="form-control"
                                id="datePicker"
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                                //required
                            />
                        </div>
                        <div className="col-md-3">
                            <button className="btn btn-primary fw-bold btncolor mt-4" type="submit">Search</button>

                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="document-list">
                        {documentdata.map((doc) => (
                            <div key={doc.id} className="document-item mb-4"> {/* Adjusted margin for spacing */}
                                <div className="card">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-center patient-name-container">
                                            {/* Patient Name */}
                                            <span className="patient-name h5 mb-0">{doc.patient_name}</span>

                                            {/* Actions */}
                                            <div className="d-flex">
                                                {/* View Document Button */}
                                                <button
                                                type="button"
                                                    onClick={() => handleDocumentClick(doc.file_path)}
                                                    className="btn btn-link me-2"
                                                    title="View Document"
                                                >
                                                    <FiShoppingBag size={24} />
                                                </button>

                                                {/* Delete Document Icon */}
                                                <button
                                                type="button"
                                                    onClick={() => handleDelete(doc.id)}
                                                    className="btn btn-link"
                                                    title="Delete Document"
                                                    style={{ color: 'red' }} // Red color for the icon
                                                >
                                                    <FiTrash2 size={24} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
                </div>
            </form>
            {loading && <CommonSpinner />}


        </div>
    );
};

export default Document;
